export const CBRE_FLOW_LAB_REQUEST_FILTER_GET_ALL_LOOKUPS_SUCCESS =
    'CBRE-FLOW-LAB-REQUEST-FILTER/GET_ALL_LOOKUPS_SUCCESS';
export const CBRE_FLOW_LAB_REQUEST_FILTER_GET_ALL_LOOKUPS_FAILURE =
    'CBRE-FLOW-LAB-REQUEST-FILTER/GET_ALL_LOOKUPS_FAILURE';
export const MODULE = 'cbre-flow-request-filter';